import AdminIndex from "@/views/admin/AdminIndex.vue";

const admin = [
  {
    path: "/admin",
    name: "admin",
    component: AdminIndex,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default admin;
